// src/data/trainers/index.js

import { bodyweightTrainers } from './BodyweightTrainers';
import strengthTrainersData from './StrengthTrainers';
import bandsTrainersData from './BandsTrainers';
import everythingTrainersData from './EverythingTrainers';
import advancedBodyweightTrainersData from './AdvancedBodyweightTrainers';

// Combine all trainers into one object
const allTrainers = {
    ...bodyweightTrainers,
    ...strengthTrainersData,
    ...bandsTrainersData,
    ...everythingTrainersData,
    ...advancedBodyweightTrainersData,
};

// Function to get trainer data by ID
export const getTrainerData = (trainerId) => {
    console.log(`Looking for trainer: ${trainerId}`);
    console.log('Available trainers:', Object.keys(allTrainers));
    const trainer = allTrainers[trainerId] || null;
    console.log(`Found trainer:`, trainer);
    return trainer;
};

// Function to get all trainers by category
export const getTrainersByCategory = (category) => {
    return Object.values(allTrainers).filter(trainer => trainer.category === category);
};

// Function to get all trainers
export const getAllTrainers = () => {
    return Object.values(allTrainers);
};

// Export specific category trainers
export { bodyweightTrainers };
export { default as strengthTrainers } from './StrengthTrainers';
export { default as bandsTrainers } from './BandsTrainers';
export { default as everythingTrainers } from './EverythingTrainers';
export { default as advancedBodyweightTrainers } from './AdvancedBodyweightTrainers';

// Export all trainers as default
export default allTrainers;